module.exports = __webpack_public_path__ + "img/bantext.c6c936bf.png";